import React from 'react';

export const WIDTH = 500,
  HEIGHT = 90;

export const BAR_WIDTH = (WIDTH / 20) * 18;
export const BAR_HEIGHT = WIDTH / 50;
export const BAR_ORIGIN_X = WIDTH / 20;
export const BAR_ORIGIN_Y = HEIGHT / 2 - BAR_HEIGHT;

const FONT_SIZE = Math.round(HEIGHT * 0.35);

interface PropsWithChildren {
  children?: React.ReactNode;
}

export const StartText: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <text
      x={BAR_ORIGIN_X}
      y={BAR_ORIGIN_Y + BAR_HEIGHT + FONT_SIZE}
      fontSize={FONT_SIZE}
      textAnchor="start"
    >
      {children}
    </text>
  );
};

export const EndText: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <text
      x={BAR_ORIGIN_X + BAR_WIDTH}
      y={BAR_ORIGIN_Y + BAR_HEIGHT + FONT_SIZE}
      fontSize={FONT_SIZE}
      textAnchor="end"
    >
      {children}
    </text>
  );
};
export const BaseBar: React.FC = () => {
  return (
    <rect
      x={BAR_ORIGIN_X}
      y={BAR_ORIGIN_Y}
      width={BAR_WIDTH}
      height={BAR_HEIGHT}
      style={{
        fill: '#dddddd',
      }}
    />
  );
};
interface Props {
  currentX: number;
  textAnchor: string;
  isOnHover: boolean;
  currentPercent: number;
  fixed: number;
}

export const PercentText: React.FC<Props> = ({
  currentX,
  textAnchor,
  isOnHover,
  currentPercent,
  fixed,
}) => {
  return (
    <text
      x={currentX}
      y={BAR_ORIGIN_Y - 4 * BAR_HEIGHT + FONT_SIZE}
      fontSize={FONT_SIZE}
      textAnchor={textAnchor}
      style={{
        display: isOnHover ? 'block' : 'none',
      }}
    >
      {(currentPercent * 100).toFixed(fixed)}%
    </text>
  );
};
